import { HttpInterceptor, HttpRequest, HttpHandler, JsonpClientBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserProfileStore } from '../stores/user-profile.store';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly _userProfileStore: UserProfileStore) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ) {
    let keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i));
    }

    //keys = keys.filter(x => x.startsWith("msal.") && x.endsWith(".idtoken"));
    keys = keys.filter(x => x.indexOf(`-idtoken-${  environment.azureAD.clientId}`) > -1);

    let token = "";
    let userProfile;

    //token = localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken');
    token = JSON.parse(localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken'))
    if (token) {
      token = token["secret"];
    }

    userProfile = this._userProfileStore.getUserProfile();

    //  const token = localStorage.getItem(keys.length > 0 ? keys[0] : 'msal.idtoken');

    if (!token) {
      return next.handle(request);
    }

    request = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${  token}`),
    });

    request = request.clone({
      headers: request.headers.set('UtcOffset', ((new Date()).getTimezoneOffset() / 60).toString()),
    });

    if (userProfile) {
      request = request.clone({
        headers: request.headers.set('UserProfile', JSON.stringify(userProfile)),
      });
    }

    return next.handle(request);
  }
}